import useSWRMutation from 'swr/mutation';
import { userService } from '../services';

interface IDeleteProfileEntityParams {
  id: number;
  userId: number;
  model: string;
}

export function useDeleteProfileEntity() {
  const { data, trigger, isMutating } = useSWRMutation<
    string,
    any,
    '/delete-entity',
    IDeleteProfileEntityParams
  >('/delete-entity', async (_, { arg }) => {
    return await userService.deleteProfileEntity(arg);
  });

  return { data, trigger, isLoading: isMutating };
}
